var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 181.000000 115.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 181,
    height: 115,
    fill: "#E1F3E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,115.000000) scale(0.100000,-0.100000)",
    fill: "#373A37",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 575 l0 -575 908 2 c499 2 739 4 534 5 -368 3 -372 3 -362 23 10 19 22 20 340 20 285 0 331 2 344 16 14 14 16 75 16 523 0 479 -1 509 -18 524 -17 16 -90 17 -846 17 -551 0 -834 -3 -847 -10 -18 -10 -19 -27 -19 -529 0 -420 3 -521 13 -530 9 -7 122 -12 348 -13 309 -3 334 -4 337 -21 3 -16 -19 -17 -362 -17 l-366 0 0 565 0 565 898 3 897 2 -907 3 -908 2 0 -575z m1698 28 l-3 -448 -779 -3 c-617 -2 -781 0 -788 10 -9 16 -11 872 -1 881 3 4 359 7 790 7 l783 0 -2 -447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 881 c-22 -14 -3 -31 35 -31 19 0 34 -2 34 -5 0 -9 -144 -175 -152 -175 -3 0 -39 27 -80 60 -40 33 -78 59 -85 58 -20 -5 -213 -190 -213 -205 0 -26 28 -9 119 75 49 45 94 82 99 82 5 0 38 -23 73 -51 99 -79 86 -81 181 27 l83 95 5 -33 c3 -20 11 -33 20 -33 20 0 28 124 8 136 -17 11 -109 11 -127 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 751 c0 -72 4 -131 8 -131 19 0 197 142 197 158 0 27 -103 91 -157 98 l-48 7 0 -132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 834 c-239 -119 -183 -474 80 -510 54 -8 128 2 152 20 16 12 12 21 -55 126 l-72 113 -2 136 -1 136 -25 3 c-14 1 -49 -9 -77 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 654 c-55 -41 -100 -79 -100 -83 0 -16 131 -211 142 -211 15 0 59 53 85 104 38 71 26 267 -16 266 -6 0 -56 -34 -111 -76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 654 c-9 -10 -9 -334 1 -335 50 -5 85 -2 93 7 5 7 8 81 7 170 l-3 159 -45 3 c-25 2 -49 0 -53 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 594 c-13 -13 -8 -262 5 -270 10 -6 47 -8 88 -5 7 1 10 50 8 139 l-3 137 -45 3 c-25 2 -49 0 -53 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 527 c-2 -7 -3 -56 -2 -108 l3 -94 55 0 55 0 0 105 0 105 -53 3 c-37 2 -54 -1 -58 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 478 c-16 -16 -16 -143 1 -155 15 -11 77 -11 95 0 16 11 16 139 0 155 -7 7 -28 12 -48 12 -20 0 -41 -5 -48 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/PowerBI.7ce94ce3eeabef717c7d216728505f8e.svg";
export { ForwardRef as ReactComponent };